import styles from './gradient-form-title.module.css';
import clsx from 'clsx';

interface GradientFormTitleProps {
  children: React.ReactNode;
  withParagraphMargins?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export function GradientFormTitle({
  children,
  withParagraphMargins = true,
  className,
  style,
}: GradientFormTitleProps) {
  return (
    <div
      className={clsx(
        styles.formTitleContainer,
        withParagraphMargins && styles.withParagraphMargins,
        className,
      )}
      style={style}
    >
      {children}
    </div>
  );
}
